// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"a7683b66","138":"a7683b66"}[chunkId] + ".chunk.css";
};